import styled from 'styled-components';
//components
import { Row } from 'components/Layout/Grid';
//interfaces
import { OrderPageSubtitleProps } from './interfaces';

export const Container = styled(Row)<OrderPageSubtitleProps>`
  width: 100%;
  align-items: center;
  display: ${(props) => props.orderDetailsPage ? "flex !important" : ""};
  margin-top: ${(props) => props.orderDetailsPage ? "" : "2em"};
  justify-content: ${(props) => props.orderDetailsPage ? "flex-end" : "center"};

  gap: ${(props) => props.orderDetailsPage ? "20px" : "40px"};

  @media only screen and (max-width: 868px) {
    gap: ${(props) => props.orderDetailsPage ? "15px" : "20px"};
  }

  @media only screen and (max-width: 782px) {
    gap: ${(props) => props.orderDetailsPage ? "5px" : "10px"};
  }

  @media only screen and (max-width: 620px) {
    flex-direction: column;
  }
`;

export const Item = styled(Row).attrs({
  className: "align-center justify-center"
})`
  gap: 5px;

  @media only screen and (max-width: 730px) {
    p {
      font-size: 10px !important;
    }
  }
`;
